<template>
	<b-modal v-model="showLogOutDialog" size="sm" lazy centered hide-header hide-footer @shown="hideButtons=false">
		<div>
			<div class="form-group form__item" v-if="!hideButtons">
				<p>{{'Do you really want to log out?'| trans}}</p>
				<div class="clearfix">
					<div class="float-left">
						<b-button @click.prevent="showLogOutDialog=!showLogOutDialog" class="btn btn-danger">{{'Cancel' | trans}}</b-button>
					</div>
					<div class="float-right">
						<spinner-button :className="'btn btn-secondary'" @click.prevent="handleLogOut"
						                :is-pending="lock">
							{{'LogOut' | trans}}
						</spinner-button>
					</div>
				</div>
			</div>
			<div v-else>
				{{'Please wait ...' | trans}}
			</div>
		</div>
	</b-modal>
</template>

<script>
	export default {
		name: "logout-confirmation",
		props: ["route"],
		data() {
			return {
				showLogOutDialog: false,
				hideButtons: false,
				lock: false
			}
		},
		mounted() {
			this.EventBus.$on('confirmLogout', () => {
				this.showLogOutDialog = true;
			});
		},
		methods: {
			async handleLogOut() {
				this.lock = true;
				let result = await axios.post(this.route, {})
					.finally(() => {this.lock=false});
				this.hideButtons = true;
				location.href=result.data.redirect;
			}
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/logout-confirmation.vue